/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TrailProvision } from './trailProvision';
import { PossibleInsurance } from './possibleInsurance';


export interface KreditInsuranceInfo { 
    possibleInsurances?: Array<PossibleInsurance>;
    submissionId?: string;
    chosenInsuranceId?: string;
    chosenPackageId?: string;
    continueWithout?: boolean;
    mailSent?: boolean;
    selectionReactivated?: boolean;
    termsAcceptedAt?: string;
    kreditInsuranceState?: KreditInsuranceInfo.KreditInsuranceStateEnum;
    cancellationReminder?: KreditInsuranceInfo.CancellationReminderEnum;
    submittedAt?: string;
    cancelledAt?: string;
    cancellationSource?: KreditInsuranceInfo.CancellationSourceEnum;
    applicationDate?: string;
    insuranceStartDate?: string;
    insuranceEndDate?: string;
    createdAt?: string;
    modifiedAt?: string;
    updatedAt?: string;
    deductionState?: KreditInsuranceInfo.DeductionStateEnum;
    closingDate?: string;
    deductionDate?: string;
    executionDate?: string;
    stornoDate?: string;
    trailProvisions?: Array<TrailProvision>;
    priceNetto?: number;
    commission?: number;
    withdrawnAt?: string;
}
export namespace KreditInsuranceInfo {
    export type KreditInsuranceStateEnum = 'NEW' | 'SUBMITTED' | 'CANCELLED' | 'WITHDRAWN';
    export const KreditInsuranceStateEnum = {
        New: 'NEW' as KreditInsuranceStateEnum,
        Submitted: 'SUBMITTED' as KreditInsuranceStateEnum,
        Cancelled: 'CANCELLED' as KreditInsuranceStateEnum,
        Withdrawn: 'WITHDRAWN' as KreditInsuranceStateEnum
    };
    export type CancellationReminderEnum = 'FIRST' | 'SECOND';
    export const CancellationReminderEnum = {
        First: 'FIRST' as CancellationReminderEnum,
        Second: 'SECOND' as CancellationReminderEnum
    };
    export type CancellationSourceEnum = 'CANCELLED_BY_CUSTOMER' | 'CANCELLED_BY_CRM' | 'CANCELLED_BY_AXA_REPORT' | 'CANCELLED_AFTER_LOAN_STORNO' | 'CANCELLED_BY_VAULT';
    export const CancellationSourceEnum = {
        ByCustomer: 'CANCELLED_BY_CUSTOMER' as CancellationSourceEnum,
        ByCrm: 'CANCELLED_BY_CRM' as CancellationSourceEnum,
        ByAxaReport: 'CANCELLED_BY_AXA_REPORT' as CancellationSourceEnum,
        AfterLoanStorno: 'CANCELLED_AFTER_LOAN_STORNO' as CancellationSourceEnum,
        ByVault: 'CANCELLED_BY_VAULT' as CancellationSourceEnum
    };
    export type DeductionStateEnum = 'ENTITLED' | 'DEDUCTED' | 'DEDUCTED_CLICK' | 'DEDUCTED_LEAD' | 'DEDUCTED_ONGOING' | 'EXPIRED' | 'CANCELED' | 'NOT_AVAILABLE' | 'STORNO';
    export const DeductionStateEnum = {
        Entitled: 'ENTITLED' as DeductionStateEnum,
        Deducted: 'DEDUCTED' as DeductionStateEnum,
        DeductedClick: 'DEDUCTED_CLICK' as DeductionStateEnum,
        DeductedLead: 'DEDUCTED_LEAD' as DeductionStateEnum,
        DeductedOngoing: 'DEDUCTED_ONGOING' as DeductionStateEnum,
        Expired: 'EXPIRED' as DeductionStateEnum,
        Canceled: 'CANCELED' as DeductionStateEnum,
        NotAvailable: 'NOT_AVAILABLE' as DeductionStateEnum,
        Storno: 'STORNO' as DeductionStateEnum
    };
}


